import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';

import { CourtEventNoteSaveSelectors } from './court-event-note-save.selectors';
import * as actions from './court-event-note-save.actions';

@Injectable({ providedIn: 'root' })
export class CourtEventNoteSaveFacade {
    @Select(CourtEventNoteSaveSelectors.isFormValid) isFormValid$: Observable<boolean>;
    @Select(CourtEventNoteSaveSelectors.isFormLoading) isFormLoading$: Observable<boolean>;

    constructor(private store: Store) {}

    saveCourtEventNote = (courtEventId: string) => this.store.dispatch(new actions.SaveCourtEventNoteAction(courtEventId));
    resetCourtEventNoteForm = () => this.store.dispatch(new actions.ResetCourtEventNoteFormAction());
}
